import StaticPageLayout from '@/components/layout/StaticPageLayout';
import distressedImg from '@/images/distressed.png';

const linkClass =
  'text-primary-600 underline transition-colors hover:text-primary-500';

const tutorials: { title: string; description: React.ReactNode; videoId: string }[] = [
  {
    title: 'Creating a Free BandJerry Account',
    description:
      'In this video we walk through the process of creating a new BandJerry account. With a Gmail account, it just requires one click.',
    videoId: 'eQIpR2bUy38',
  },
  {
    title: 'Your First Chat With Jerry',
    description: 'In this video we review what your first chat with Jerry looks like. You share your background and goals with Jerry, and he creates custom marketing moves tailored to your band\'s situation.',
    videoId: '9La_y1kHQno',
  },
  {
    title: "What's in a Move",
    description: 'Here we walk through some example marketing moves created by Jerry. These include detailed content to help a new band set up an online presence, as well as targeted venue suggestions and contact information to book shows.',
    videoId: 'UPUDFX2g-rU',
  },
  {
    title: 'Building a Free EPK in BandJerry',
    description: (
      <>
        In this video we walk through the process of creating a free EPK in
        BandJerry.{' '}
        <a
          href="https://epk.bandjerry.com/thefakegreenday"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          You can see the demo EPK here.
        </a>
      </>
    ),
    videoId: 'AK68AACqTg0',
  },
  {
    title: 'Building a Free Microsite in BandJerry',
    description: (
      <>
        Here we will walk through the process of setting up a microsite for your
        band in BandJerry.{' '}
        <a
          href="https://site.bandjerry.com/thefakebeatles"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          You can view the demo microsite here.
        </a>
      </>
    ),
    videoId: 'ktBHBdE6vM8',
  },
  {
    title: 'Building a Free Link-in-Bio Page in BandJerry',
    description: (
      <>
        In this video we walk through the process of setting up a link-in-bio
        page in BandJerry.{' '}
        <a
          href="https://bandjerry.link/thefakekidrock"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          You can view the demo link-in-bio page here.
        </a>
      </>
    ),
    videoId: '3t_3JgzWz7U',
  },
];

export default function TutorialsPage() {
  return (
    <StaticPageLayout>
      {/* ============ HERO / HEADER ============ */}
      <section
        className="relative z-[6] -mt-[50px] bg-[#111] bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${distressedImg})` }}
      >
        <div className="mx-auto max-w-4xl px-6">
          <h1 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[85px]">
            TUTORIALS
          </h1>
          <p className="mt-4 text-lg font-semibold text-primary-600">
            Step-by-step video guides to help you get the most out of BandJerry
          </p>
        </div>
      </section>

      {/* ============ VIDEO LIST ============ */}
      <section className="relative -mt-[50px] bg-[#222] px-6 pb-32 pt-[calc(100px+50px)] md:-mt-[80px] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_100%,0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_100%,0_100%)]">
        <div className="mx-auto max-w-4xl space-y-10">
          {tutorials.map((tutorial) => (
            <article
              key={tutorial.title}
              className="overflow-hidden rounded-lg border border-neutral-300 bg-neutral-200"
            >
              {/* Responsive 16:9 video embed */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute inset-0 h-full w-full"
                  src={`https://www.youtube.com/embed/${tutorial.videoId}`}
                  title={tutorial.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>

              {/* Title & description */}
              <div className="p-8">
                <h2 className="font-heading text-2xl uppercase text-white sm:text-3xl">
                  {tutorial.title}
                </h2>
                <p className="mt-3 text-base text-neutral-600 md:text-lg">
                  {tutorial.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </StaticPageLayout>
  );
}
